/**
 * Critères de la vitrine <-> URL.
 *
 * Les critères vivent dans l'URL : une recherche se partage, se met en favori
 * et survit au bouton « retour ». Les anciens paramètres de /listings
 * (brand, model, price_max, year_min, mileage_max, sort=marge) sont traduits,
 * parce que des liens ont été partagés et que la page redirige ici.
 */

export const CLES = [
  'q', 'marque', 'modele', 'budget', 'departement', 'energie', 'boite',
  'prix_min', 'prix_max', 'annee_min', 'km_max', 'ecart_min', 'tri', 'vue', 'page',
];

const ANCIENS = {
  brand: 'marque', model: 'modele', price_min: 'prix_min', price_max: 'prix_max',
  year_min: 'annee_min', mileage_max: 'km_max',
};

export function lireCriteres(search) {
  const p = new URLSearchParams(search);
  const c = {};
  Object.entries(ANCIENS).forEach(([ancien, nouveau]) => {
    const v = p.get(ancien);
    if (v) c[nouveau] = v;
  });
  if (p.get('sort') === 'marge') {
    c.vue = 'revente';
    c.tri = 'marge';
  }
  CLES.forEach((k) => {
    const v = p.get(k);
    if (v) c[k] = v;
  });
  return c;
}

export function ecrireCriteres(c) {
  const p = new URLSearchParams();
  CLES.forEach((k) => {
    const v = c[k];
    if (v !== undefined && v !== null && v !== '') p.set(k, v);
  });
  return p.toString();
}

/** Nombre de filtres réellement posés (ni la page, ni le tri, ni la vue). */
export function nombreFiltres(c) {
  return CLES.filter((k) => !['page', 'tri', 'vue'].includes(k) && c[k]).length;
}
